import { _ } from "core-js";

function ReverceDateStr(datastr) {
  var d = datastr;
  var ii = d.indexOf("-");
  d = d.replace("-", ".");
  var jj = d.indexOf("-");
  var n1 = d.substring(0, ii);
  var n2 = d.substring(ii + 1, ii + 3);
  var n3 = d.substring(jj + 1, d.length);
  return n3 + "-" + n2 + "-" + n1;
}

function Formatdata(datastr) {
  var d = datastr;
  if (4 > d.indexOf("-")) {
    d = ReverceDateStr(d);
  }
  return Date.parse(d);
}

check_progress_slides();

// Функция для запоминания скролла в менюшке
window.onload = function () {
  function func() {
    if (sessionStorage.getItem("scrollPosition") === null) {
      var scrollPosition = 0;
    } else {
      var scrollPosition = sessionStorage.getItem("scrollPosition");
      $("#siteMenuBar .scrollable-container").scrollTop(scrollPosition);
    }

    $("#siteMenuBar li").on("click", function () {
      var scrollPosition = $("#siteMenuBar .scrollable-container").scrollTop();
      sessionStorage.setItem("scrollPosition", scrollPosition);
    });
  }

  setTimeout(func, 5);
};
// Функция для запоминания скролла в менюшке

$(window).on("beforeunload", function () {
  var href = window.location.href;

  var url = href.indexOf("/exam/");

  if (url != -1) {
    localStorage.removeItem("noMoreExam");
  }
});

function getDateDiff(time1, time2) {
  var str1 = time1.split(".");
  var str2 = time2.split(".");
  var t1 = new Date(str1[2], str1[1], str1[0] - 1);
  var t2 = new Date(str2[2], str2[1], str2[0] - 1);
  return t2 - t1;
}

$(document).on("changeDate", ".date_start", function () {
  console.log("changeDate");
  $(".date_start").datepicker("hide");
  if (getDateDiff($(".date_start").data("date"), $(".date_end").val()) < 0) {
    $(".date_start").val($(".date_end").val());
  } else {
    $(".date_start").val($(".date_start").data("date"));
  }
});

$(document).on("changeDate", ".date_end", function () {
  console.log("changeDate");
  $(".date_end").datepicker("hide");
  if (getDateDiff($(".date_start").val(), $(".date_end").data("date")) < 0) {
    $(".date_end").val($(".date_start").val());
  } else {
    $(".date_end").val($(".date_end").data("date"));
  }
});

$(document).on("changeDate", ".datepicker_delayedsend", function () {
  $(".datepicker_delayedsend").datepicker("hide");
  $(".datepicker_delayedsend").val($(".datepicker_delayedsend").data("date"));
});

$(document).on("click", ".pincode-btn", function () {
  var theme_id = $(this).attr("id");
  var group_id = $(this).attr("data-group");

  Swal.fire({
    title: "Введите пин-код для доступа к экзамену",
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    confirmButtonText: "Ввод",
    showLoaderOnConfirm: true,
    cancelButtonText: "Отмена",
    preConfirm: (pincode) => {
      return fetch(`/live_exam/` + theme_id + `/${pincode}`)
        .then((response) => response.json())
        .catch((error) => {
          Swal.showValidationMessage(`Ошибка: ${error}`);
        });
    },
    allowOutsideClick: () => !Swal.isLoading(),
  }).then((result) => {
    if (result.value.status === "success") {
      Swal.fire({
        title: `Вам открыт доступ к экзамену`,
        confirmButtonText: `<a href="exam/${group_id}/${theme_id}/" style="color:white;" >Начать экзамен</a>`,
        confirmButtonAriaLabel: "Начать экзамен!",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Неверный пин-код",
        text: "Обратитись к своему куратору для получения пин-кода к экзамену",
      });
    }
  });
});

$(window).resize(function () {
  $(".filter").width(180);
});

$(document).on("click", "#toggleMenubar", function () {
  if (localStorage.getItem("menubar-fold")) {
    localStorage.setItem("menubar-fold", "false");
  } else {
    localStorage.setItem("menubar-fold", "true");
  }
});

$(document).on("click", ".stats4exam_link", function () {
  var requests4services_id = sessionStorage.getItem("requests4services_id");
  var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
  var user_id = 0;

  $.get(
    "getExamsPersons",
    { id: requests4services_id, user_id: user_id },
    function (data) {
      $("#getExamPersons").html(data.html);
    }
  );

  $("#control_study").find(".nav-link").removeClass("active");

  $(".stats4exam_link").find("a.nav-link").addClass("active");

  $("#trainingStat").removeClass("active");

  $("#stats4exam").addClass("active");
});

$(document).on("click", "#stats_study", function () {
  $("#stats4exam").removeClass("active");

  $("#trainingStat").addClass("active");
});

//ПРОГРЕСС ВИДЕО И СЛАЙДОВ. ПОРЯДОК ХОДА ФУНКЦИЙ НЕ ТРОГАТЬ!!!
var topic_slide = sessionStorage.getItem("topic");
var max_slide = sessionStorage.getItem("max_slide");

$(document).on("click", "#topicsProgressTable a", function () {
  check_progress_slides();
  topic_slide = $(this).data("topic");
  sessionStorage.setItem("topic", topic_slide);
  max_slide = $(this).data("max-slide");
  sessionStorage.setItem("max_slide", max_slide);
});

$(document).on("click", ".btn.edustart", function () {
  check_progress_slides();
  topic_slide = $(this).attr("eduid");
  sessionStorage.setItem("topic", topic_slide);
});

max_slide = $(document.body)
  .find('[data-topic="' + sessionStorage.getItem("topic") + '"]')
  .data("max-slide");
sessionStorage.setItem("max_slide", max_slide);

$(document).on("click", ".topics-list a", function () {
  check_progress_slides();
  topic_slide = $(this).data("topic");
  max_slide = $(this).data("max-slide");
  sessionStorage.setItem("prev_topic", sessionStorage.getItem("topic"));
  sessionStorage.setItem("topic", topic_slide);
  sessionStorage.setItem("max_slide", max_slide);
});

$(window).on("storage", function (e) {
  // var user_slide = sessionStorage.getItem('user_slide');
  // var full_count_slide = sessionStorage.getItem('full_count_slide');
  // var topic = window.location.href.split('/').pop();
  // var person_id = sessionStorage.getItem('person_edu_id_edu');
  // var main_id = sessionStorage.getItem('main_edu_id_edu');
  // var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
  // $.get('/lets_test', {_token: CSRF_TOKEN,topic: topic,person_id: person_id, main_id: main_id}, function (data) {
  //    if(data.check == 0 && full_count_slide == user_slide) {
  //         const swalWithBootstrapButtons = Swal.mixin({
  //           customClass: {
  //             confirmButton: 'btn btn-success',
  //             cancelButton: 'btn btn-danger'
  //           },
  //           buttonsStyling: false,
  //         })
  //         Swal.fire({
  //         type:'success',
  //         title:'',
  //         showCancelButton: true,
  //         confirmButtonText:
  //         '<a href="/tests/'+topic+'/training" class="start_test" >Пройти тест</a>',
  //         cancelButtonText: 'Пройти позже',
  //         html:
  //            'Вы прослушали тему, пройдите тест по материалу'+
  //            '<br>',
  //            });
  //     }
  // });
});

$(document).on(
  "input",
  "#requestsrequests4servicesFormkolvoField",
  function () {
    var cost = document.getElementById(
      "requestsrequests4servicesFormprice_costField"
    ).value;
    var count = document.getElementById(
      "requestsrequests4servicesFormkolvoField"
    ).value;

    var total_cost = cost * count;

    document.getElementById(
      "requestsrequests4servicesFormtotal_costField"
    ).value = total_cost;
  }
);

function check_progress_slides() {
  // var user_slide = sessionStorage.getItem('user_slide');
  // var full_count_slide = sessionStorage.getItem('full_count_slide');
  // var user_slide = sessionStorage.getItem('user_slide');
  // var max_slide = sessionStorage.getItem('max_slide');
  // var topic_slide = sessionStorage.getItem('topic');
  //  if (topic_slide > 0 && user_slide > 0 && user_slide > max_slide) {
  //     var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
  //     $.ajax({
  //         url: '/slidesProgress',
  //         type: 'POST',
  //         data: {
  //             _token: CSRF_TOKEN,
  //             topic_id: topic_slide,
  //             user_slide: user_slide,
  //             full_count_slides: full_count_slide
  //         },
  //         dataType: 'JSON',
  //         success: function (data) {
  //             sessionStorage.setItem('user_slide', 0);
  //             sessionStorage.setItem('topic', 0);
  //         }
  //     });
  // sessionStorage.setItem('user_slide', 0);
  //  }
}

$(document).ready(function () {
  var topic_video = topic_slide;

  function check_progress_video() {
    var user_video_time = sessionStorage.getItem("user_video_time");
    var full_video_time = sessionStorage.getItem("full_video_time");

    if (topic_video > 0 && user_video_time > 0) {
      var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

      $.ajax({
        url: "/videoProgress",
        type: "POST",
        data: {
          _token: CSRF_TOKEN,
          topic_id: topic_video,
          full_video_time: full_video_time,
          user_video_time: user_video_time,
        },
        dataType: "JSON",
        success: function (data) {
          sessionStorage.setItem("user_video_time", 0);
          sessionStorage.setItem("full_video_time", 0);
        },
      });
    }
  }
  if ($("#slideshow").length != 0) {
    jQuery(document).on("click", function (e) {
      var el = $("#slideshow");
      if (jQuery(e.target).closest(el).length) return;
      check_progress_slides();
      check_progress_video();
    });

    addEventListener(
      "popstate",
      function (e) {
        $.get(window.location.search, function (data) {
          check_progress_slides();
          check_progress_video();
        });
      },
      false
    );

    $(window).bind("beforeunload", function () {
      if (sessionStorage.getItem("prev_topic") != null) {
        sessionStorage.setItem("topic", sessionStorage.getItem("prev_topic"));
      }
      check_progress_slides();
      check_progress_video();
    });
  }
  //ПРОГРЕСС ВИДЕО И СЛАЙДОВ

  $(document).on("click", ".red-div-topics", function () {
    var topic = $(this).data("topic_id");
    var theme = $(this).data("theme_id");
    var group_id = $(this).data("group_id");

    Swal.fire({
      icon: "error",
      title: "",
      showCancelButton: true,
      heightAuto: false,
      confirmButtonText:
        '<a href="/tests/' +
        group_id +
        "/" +
        topic +
        "/training/" +
        theme +
        '" target="_parent" class="start_test" >' +
        HSE_lang.red_div_topics_btn_confirm_text +
        "</a>",
      cancelButtonText: HSE_lang.red_div_topics_btn_cancel_text,
      html: HSE_lang.red_div_topics_text + "<br>",
    });
  });

  $(document).on("click", ".green-div-topics", function () {
    var topic = $(this).data("topic_id");
    var theme = $(this).data("theme_id");

    Swal.fire({
      icon: "success",
      title: "",
      heightAuto: false,
      html: HSE_lang.success_test + "<br>",
    });
  });

  $(document).on("click", ".gray-div-topics", function () {
    var topic = $(this).data("topic_id");
    var theme = $(this).data("theme_id");
    var group_id = $(this).data("group_id");

    Swal.fire({
      icon: "success",
      heightAuto: false,
      title: "",
      allowOutsideClick: false,
      focusConfirm: false,
      target: "body",
      showCancelButton: false,
      showConfirmButton: false,
      html:
        HSE_lang.text_slides +
        "<br><br>" +
        '<div style="z-index: 1;flex-wrap: wrap;align-items: center;justify-content: center;display: flex;outline:none;">' +
        '<a href="/tests/' +
        group_id +
        "/" +
        topic +
        "/training/" +
        theme +
        '" target="_parent" class="start_test">' +
        '<button type="button" class="swal2-confirm swal2-styled" style="display: inline-block; border-left-color: rgb(255, 102, 32); border-right-color: rgb(255, 102, 32);">' +
        HSE_lang.go_test +
        "</button></a>" +
        '<div onclick = "Swal.close();" class="swal2-cancel swal2-styled" style="display: inline-block;">' +
        HSE_lang.red_div_topics_btn_cancel_text +
        "</div>" +
        "</div>",
    });
  });

  $(document).on("click", ".start_test.disabled", function () {
    var topic = $(this).data("topic_id");

    Swal.fire({
      icon: "info",
      title: HSE_lang.disabled_tests_title,
      html: HSE_lang.consistent_form + "<br>" + HSE_lang.listen_topic,
      heightAuto: false,
    });
  });

  $(document).on("click", ".add_settings", function () {
    sessionStorage.setItem("requests4services_id", $(this).attr("id"));
    sessionStorage.setItem("user_id", 0);

    var requests4services_id = $(this).attr("id");
    var user_id = 0;

    get_modal_settings(requests4services_id, user_id);
  });

  function get_modal_settings($requests4services_id, $user_id) {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/getModalSettings",
      type: "GET",
      data: {
        _token: CSRF_TOKEN,
        id: $requests4services_id,
        user_id: $user_id,
      },
      success: function (data) {
        //$('#addSettings').html(data);

        $("#type_edu").val(data.type_edu);
        $("#depth_study").val(data.depth_study);
        document
          .getElementById("date_start")
          .setAttribute("value", data.date_start);
        document
          .getElementById("date_end")
          .setAttribute("value", data.date_end);

        $(".date_start").datepicker("setStartDate", data.min_date);
        $(".date_start").datepicker("setEndDate", data.max_date);

        $(".date_end").datepicker("setStartDate", data.min_date);
        $(".date_end").datepicker("setEndDate", data.max_date);

        // $(".date_start").val(data.date_start);
        // $(".date_end").val(data.date_end);
        $("#questions_edu").val(data.questions);
        $("#attempts").val(data.exam_attempts);
        $("#limit").val(data.exam_limit);
        $("#questions_exam").val(data.exam_questions);
        $("#time_exam").val(data.exam_time_exam);

        $("#questions_stat").val(data.questions_stat);
        $("#depth_study_test").val(data.depth_study_test);
      },
    });
  }

  $(document).on("click", ".get_stats4users", function () {
    var requests4services_id = sessionStorage.getItem("requests4services_id");
    var user_id = $(this).attr("id");

    $.get(
      "getStatsEdu4Persons",
      { id: requests4services_id, user_id: user_id },
      function (data) {
        $("#get_themes_id").html(data.test_html);
        $("#get_topics_stats").html(data.topics_html);
      }
    );
  });

  $(document).on("click", ".add_settings_personal", function () {
    var requests4services_id = sessionStorage.getItem("requests4services_id");
    sessionStorage.setItem("user_id", $(this).attr("id"));

    get_modal_settings(requests4services_id, $(this).attr("id"));
  });

  $(document).on("click", ".start_exam_btn", function () {
    var requests4services_id = $(this).attr("id");
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    $.get(
      "getExamStart",
      { id: requests4services_id, _token: CSRF_TOKEN },
      function (data) {}
    );
  });

  $(document).on("click", ".toggle", function () {
    $(".cover").toggleClass("switch-block");
    $("#fotorama").toggleClass("fotorama--hidden");
    $("#fotorama").toggleClass("fotorama__img");
  });

  $(document).on("click", "#save_edu_exam_settings", function () {
    var user_id = sessionStorage.getItem("user_id");
    var requests4services_id = sessionStorage.getItem("requests4services_id");
    var type_edu = $("#type_edu").val();
    var depth_study = document.getElementsByName("depth_study")[0].value;
    var date_start = document.getElementsByName("date_start")[0].value;
    var date_end = document.getElementsByName("date_end")[0].value;
    var questions_edu = document.getElementsByName("questions_edu")[0].value;

    var questions_stat = document.getElementsByName("questions_stat")[0].value;
    var depth_study_test =
      document.getElementsByName("depth_study_test")[0].value;

    var is_internal = document.getElementsByName("is_internal")[0].value;

    var attempts = document.getElementsByName("attempts")[0].value;
    var limit = document.getElementsByName("limit")[0].value;
    var questions_exam = document.getElementsByName("questions_exam")[0].value;
    var time_exam = document.getElementsByName("time_exam")[0].value;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/addSettingsEdu",
      type: "POST",
      data: {
        _token: CSRF_TOKEN,
        id: requests4services_id,
        type_edu: type_edu,
        depth_study: depth_study,
        date_start: date_start,
        date_end: date_end,
        questions_edu: questions_edu,
        questions_stat: questions_stat,
        depth_study_test: depth_study_test,
        user_id: user_id,
      },
    });

    $.ajax({
      url: "/addSettingsExam",
      type: "POST",
      data: {
        _token: CSRF_TOKEN,
        id: requests4services_id,
        attempts: attempts,
        limit: limit,
        questions_exam: questions_exam,
        time_exam: time_exam,
        user_id: user_id,
      },
      dataType: "JSON",
      success: function (data) {
        if (user_id > 0) {
          $.get(
            "getPersons4Services",
            { id: requests4services_id, view: "distance", _token: CSRF_TOKEN },
            function (data) {
              $("#persons4services").html(data);
            }
          );
        } else {
          if (is_internal == "1") {
            $.get("/internal", function (data) {
              $(".page").html(data);
            });
          } else {
            $.get("/distance", function (data) {
              $(".page").html(data);
            });
          }
        }
      },
    });

    $("#addSettings").modal("hide");
    Swal.fire({
      icon: "success",
      title: "Успешно изменено!",
      heightAuto: false,
    });
  });

  $("#check_exam_attempt").ready(function () {
    var id = $("#check_exam_attempt").data("r4s_id");
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    var href = window.location.href;

    var url = href.indexOf("results");

    if (url != -1) {
      $.get(
        "/check_exam_attempt",
        { id: id, _token: CSRF_TOKEN },
        function (data) {
          if (data.count == 0) {
            Swal.fire({
              icon: "warning",
              title: HSE_lang.disabled_tests_title,
              html:
                HSE_lang.check_exam_attempt_1 +
                "<br><br>" +
                HSE_lang.check_exam_attempt_2 +
                "<br><br>" +
                HSE_lang.check_exam_attempt_3,
            });
          }
        }
      );
    }
  });

  $(".access_exam").ready(function () {
    var exam_access = $(".access_exam").data("access_exam");
    var test_disabled = $(".access_exam").data("test_disabled");
    var href = window.location.href;
    var url = href.indexOf("results");
    var exam_id = $(".access_exam").data("exam_id");
    var group_id = $(".access_exam").data("group_id");
    var is_exam = $(".access_exam").data("is_exam");
    var test_id = $(".access_exam").data("test_id");
    if (is_exam == 1) {
      var type_test_text = 'пробного экзамена'
    }
    else {
      var type_test_text = 'промежуточного тестирования'
    }


    if (url != -1 && (exam_access == 1 || test_disabled == 1)) {
      Swal.fire({
        icon: "success",
        heightAuto: false,
        title: "",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: '600px',
        focusConfirm: false,
        target: 'body',
        html: HSE_lang.done_learn_1 + '<br>Ознакомиться с результатами ' + type_test_text + ' Вы можете <a href="/downloadResultsPdf/' + test_id + '/' + group_id + '/results" target="_blank" class="font-weight-900">здесь</a>.<br><br>' + HSE_lang.done_learn_2 + "<br><br>" + HSE_lang.done_learn_3 + '<br><br>' +
          '<div style="z-index: 1;flex-wrap: no-wrap;align-items: center;justify-content: center;display: flex;outline:none;">' +
          '<a href="/education/' + group_id + "/" + exam_id + '/topics"  target="_parent" class="start_test">' +
          '<button type="button" class="swal2-cancel swal2-styled" style="display: inline-block; border-left-color: rgb(255, 102, 32); border-right-color: rgb(255, 102, 32);">' +
          HSE_lang.red_div_education_again +
          '</button></a>' +
          '<a href="/exam/' + group_id + "/" + exam_id + '/training"  target="_parent" class="start_test">' +
          '<button type="button" class="swal2-confirm swal2-styled" style="display: inline-block; border-left-color: rgb(255, 102, 32); border-right-color: rgb(255, 102, 32);">' +
          HSE_lang.go_trainig_exam +
          '</button></a>' +
          '<a href="/exam/' + group_id + "/" + exam_id + '" target="_parent" class="start_test">' +
          '<button type="button" class="swal2-confirm swal2-styled" style="display: inline-block; border-left-color: rgb(255, 102, 32); border-right-color: rgb(255, 102, 32);">' +
          HSE_lang.go_exam +
          '</button></a>' +
          '</div>',


      }).then((result) => {

      });
    }
  });

  // menu_active();

  var activeSub = $(document).find(".active-sub");
  if (activeSub.length > 0) {
    activeSub.parent().show();
    activeSub.closest(".arrow").addClass("open");
    activeSub.closest().addClass("open");
  }

  $(".datatable").each(function () {
    var options = {
      retrieve: true,
      dom: 'frtip<"actions">',
      columnDefs: [],
      iDisplayLength: 100,
      aaSorting: [],
    };

    if ($(this).hasClass("dt-select")) {
      options.select = {
        style: "multi",
        selector: "td:first-child",
      };

      options.columnDefs.push({
        orderable: false,
        className: "select-checkbox",
        targets: 0,
      });
    }

    $(this).dataTable(options);
  });

  if (typeof window.route_mass_crud_entries_destroy != "undefined") {
    $(".datatable")
      .siblings(".actions")
      .html(
        '<a href="' +
          window.route_mass_crud_entries_destroy +
          '" class="btn btn-xs btn-danger js-delete-selected" onclick="return confirm(\'Are you sure\');" style="margin-top:0.755em;margin-left: 20px;">Delete selected</a>'
      );
  }

  $(document).on("input", ".procent", function () {
    var id = $(this).attr("id");

    var limit = document.getElementById(id).value;

    if (limit > 100) {
      document.getElementById(id).value = 100;
    }

    var string = /[-\.;":'a-zA-Zа-яА-Я]/;

    if (limit.charAt(0) == 0 || string.test(limit)) {
      document.getElementById(id).value = "";
    }
  });

  $("#events").bind("click", function () {
    $.get("/calendar", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/calendar");
  });

  $("#ochnoe").bind("click", function () {
    $.get("/ochnoe", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/ochnoe");
  });

  $("#result").bind("click", function () {
    $.get("/results", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/results");
  });

  $("#tasks").bind("click", function () {
    $.get("/todo", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/todo");
  });

  $("#settings").bind("click", function () {
    $.get("/settings", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/settings");
  });

  $("#shtat").bind("click", function () {
    $.get("/users", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/users");
  });

  $("#contragenty_settings").bind("click", function () {
    $.get("/contragenty", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/contragenty");
  });

  $(document).on("click", "#training_statistics", function () {
    var id = sessionStorage.getItem("theme_id");
    var type = "topics";
    var main_edu_id = sessionStorage.getItem("main_edu_id_edu");
    var person_edu_id = sessionStorage.getItem("person_edu_id_edu");
    var request4services_id = sessionStorage.getItem("request4services_id_edu");

    $.ajax({
      url: "/topicsgetjson",
      type: "GET",
      data: {
        edu: id,
        main_edu_id: main_edu_id,
        person_edu_id: person_edu_id,
        request4services_id: request4services_id,
      },
      dataType: "JSON",
      success: function (data) {
        $(".page").html(data.html);
      },
    });
    window.history.pushState("", "", "/education/" + id + "/" + type);
  });

  // $(document).on('click', '.edustart', function () {
  //     var id = this.getAttribute('eduid');
  //     var request4services_id = sessionStorage.getItem('request4services_id_edu');

  //     $.ajax({

  //         url: '/startlearning',
  //         type: 'GET',
  //         data: {  edu: id,
  //                  request4services_id: request4services_id},
  //         dataType: 'JSON',
  //         success: function (data) {
  //             $('.page').html(data.html);

  //         }

  //     });
  //     window.history.pushState("", "", '/education/' + id);

  // });

  $(document).on("click", ".start_test.success", function () {
    Swal.fire({
      icon: "success",
      heightAuto: false,
      title: "",
      html: HSE_lang.start_test_success,
    });
  });

  $(document).on("click", ".order_alerts_setting", function () {
    var order_id = this.getAttribute("order_id");
    document
      .getElementById("save_contragenty_alert_order")
      .setAttribute("order_id", order_id);
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    $.ajax({
      url: "/contragentyajax",
      type: "GET",
      data: {
        _token: CSRF_TOKEN,
        order_id: order_id,
        actionprt: "getalertbyorder",
      },
      dataType: "JSON",
      success: function (data) {
        if (data.status == "success") {
          document.getElementById("orders_visits_stat").value =
            data.alerts.visits;
          document.getElementById("orders_results_stat").value =
            data.alerts.result1;
        } else {
          alert("Произошла непредвиденная ошибка!");
        }
        //      $('.page').html(data.html);
      },
    });
  });

  $(document).on("click", "#save_contragenty_alert_order", function () {
    var order_id = this.getAttribute("order_id");

    var visits = document.getElementById("orders_visits_stat").value;
    var result1 = document.getElementById("orders_results_stat").value;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/contragentyajax",
      type: "GET",
      data: {
        _token: CSRF_TOKEN,
        order_id: order_id,
        actionprt: "savealertfororder",

        visits: visits,
        result1: result1,
      },
      dataType: "JSON",
      success: function (data) {
        if (data.status == "success") {
        } else {
          alert("Произошла непредвиденная ошибка!");
        }
        //      $('.page').html(data.html);
      },
    });
  });

  $(document).on("click", "#save_contragentyalerts", function () {
    localStorage.setItem("contragenty_id", "7312");
    var contragenty_id = localStorage.getItem("contragenty_id");

    var form_alert_email = document.getElementById("form_alert_email").value;
    var form_alert_phone = document.getElementById("form_alert_phone").value;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/contragentyajax",
      type: "GET",
      data: {
        _token: CSRF_TOKEN,
        contragenty_id: contragenty_id,
        actionprt: "savetoportalalerts",

        form_alert_email: form_alert_email,
        form_alert_phone: form_alert_phone,
      },
      dataType: "JSON",
      success: function (data) {
        if (data.status == "success") {
        } else {
          alert("Произошла непредвиденная ошибка!");
        }
        //      $('.page').html(data.html);
      },
    });
  });

  $(document).on("input", ".autosave_email", function () {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    var mail_id = this.getAttribute("mail_id");
    var theme = document.getElementById("form_mail_body_" + mail_id).value;
    var body = document.getElementById("form_mail_theme_" + mail_id).value;

    $.post(
      "autosaveemail",
      { _token: CSRF_TOKEN, mail_id: mail_id, theme: theme, body: body },
      function (data) {
        console.log("Saved!");
      }
    );
  });

  $(document).on("input", ".save_contragentycontacts", function () {
    localStorage.setItem("contragenty_id", "7312");
    var contragenty_id = localStorage.getItem("contragenty_id");

    var form_fullname = document.getElementById("form_fullname").value;
    var form_shortname = document.getElementById("form_shortname").value;
    var form_inn = document.getElementById("form_inn").value;
    var form_kpp = document.getElementById("form_kpp").value;
    var form_activity = document.getElementById("form_activity").value;
    var form_city = document.getElementById("form_city").value;
    var form_addr = document.getElementById("form_addr").value;
    var form_post = document.getElementById("form_post").value;
    var form_bossname = document.getElementById("form_bossname").value;

    var form_bankname = document.getElementById("form_bankname").value;
    var form_bankbic = document.getElementById("form_bankbic").value;
    var form_bankacc = document.getElementById("form_bankacc").value;
    var form_bankcity = document.getElementById("form_bankcity").value;
    var form_banknum = document.getElementById("form_banknum").value;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/contragentyajax",
      type: "GET",
      data: {
        _token: CSRF_TOKEN,
        contragenty_id: contragenty_id,
        actionprt: "savetoportal",

        form_fullname: form_fullname,
        form_shortname: form_shortname,
        form_inn: form_inn,
        form_kpp: form_kpp,
        form_activity: form_activity,
        form_city: form_city,
        form_addr: form_addr,
        form_post: form_post,
        form_bossname: form_bossname,

        form_bankname: form_bankname,
        form_bankbic: form_bankbic,
        form_bankacc: form_bankacc,
        form_bankcity: form_bankcity,
        form_banknum: form_banknum,
      },
      dataType: "JSON",
      success: function (data) {
        if (data.status == "success") {
          // alert("Сохранено!");
        } else {
          alert("Произошла непредвиденная ошибка!");
        }
        //      $('.page').html(data.html);
      },
    });
  });

  $("#tests").bind("click", function () {
    $.get("/tests", function (data) {
      $(".page").html(data);
    });

    $(".site-menu-item").removeClass("active");

    $("#exam").addClass("active");

    window.history.pushState("", "", "/tests");
  });

  $(document).on("click", ".orders_by_id", function () {
    var order_id = this.getAttribute("order_id");
    $.get("/orders/" + order_id, function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/orders/" + order_id);
  });

  $(document).on("click", ".orders_tab", function () {
    $.get("/orders", function (data) {
      $(".page").html(data);
    });

    window.history.pushState("", "", "/orders");
  });

  // addEventListener("popstate", function(e) {
  //     window.location.href = document.referrer;
  // }, false);

  $(".table-section-arrow").bind("click", function () {
    $(".test").toggleClass("attest");
    // alert('Отработал');
  });

  // Дима 21-09-2018

  $(".tabs").hover(
    function () {
      // навели мышь на элемент
      $(".tabs").removeClass("home-show");
      var hoverId = $(this).attr("id");
      $("#" + hoverId).toggleClass("home-show");
    },
    function () {
      // убрали мышь с элемента
    }
  );

  $("#sms").bind("click", function () {
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    var text_sms = document.getElementById("text_sms").value;
    var phone_number = document.getElementById("phone_number").value;

    $.ajax({
      url: "/sms",
      type: "POST",
      data: { _token: CSRF_TOKEN, text: text_sms, phone: phone_number },
      dataType: "JSON",
      success: function (data) {
        // $('#'+linkId).addClass('active');

        alert(data.msg);
      },
    });
  });

  $(".icon-answer-user").bind("click", function () {
    var id = $(this).attr("data-question");

    //alert(id);

    $("li.nav-item")
      .find(".cardTab" + id)
      .addClass("check-option");
  });

  if (
    $("#training").prev().is("input") &&
    $("#exam").prev().is("input") &&
    $("#topic_id").val() == 0
  ) {
    $(".radio-inline").bind("click", function () {
      var id = $(".nav-link.exam-tab-qwe-warning.active").text();
      var tabInExam = $("li.nav-item").find(".cardTab" + id);
      tabInExam.removeClass("exam-tab-qwe-warning");
      tabInExam.addClass("exam-tab-qwe-success");
      tabInExam.addClass("check-option");
    });
  }

  $("#auth_btn").bind("click", function () {
    sessionStorage.setItem("site_menu_item", "home");
  });

  $(document).on("click", ".detail_control_study", function () {
    var requests4services_id = $(this).attr("id");

    sessionStorage.setItem("requests4services_id", $(this).attr("id"));

    var view = "controls";

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.get(
      "getMainSettingsGroup",
      { id: requests4services_id, view: view, _token: CSRF_TOKEN },
      function (data) {
        $(".main_settings_control").html(data);
      }
    );

    $.get(
      "getPersons4Services",
      { id: requests4services_id, view: view, _token: CSRF_TOKEN },
      function (data) {
        $(".control_persons").html(data);
      }
    );

    $.get(
      "getSettingsExams",
      { id: requests4services_id, _token: CSRF_TOKEN },
      function (data) {
        $(".exam_settings").html(data);
      }
    );

    $.get("getCourseName", { id: requests4services_id }, function (data) {
      // НУЖНА ЛОКАЛИЗАЦИЯ needland

      $(".page-title.mb-10").text("Контроль обучения" + data.name);
    });

    $(".nav-item").removeClass("hide");

    $("#control_study").find(".nav-link").removeClass("active");

    $("#stats_study").find("a.nav-link").addClass("active");

    $("#exampleTop").removeClass("active");

    $("#trainingStat").addClass("active");

    $("#exampleTop").hide();

    $("#stats4exam").hide();
  });

  $(document).on("click", "#control_main_tab", function () {
    // НУЖНА ЛОКАЛИЗАЦИЯ  needland

    $(".page-title.mb-10").text("Контроль обучения");
  });

  $(document).on("click", ".settings_people_main_save_btn", function () {
    var peopleu_id = document
      .getElementById("settings_people_main_save_btn")
      .getAttribute("user_id");

    //var role_id = document.getElementById('settings_people_type').value;
    var name = document.getElementById("settings_people_firstname").value;
    var lastname = document.getElementById("settings_people_secondname").value;
    var middlename = document.getElementById(
      "settings_people_middlename"
    ).value;
    var email = document.getElementById("settings_people_email").value;
    var mobile_phone = document.getElementById("settings_people_phone").value;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/peoplestable",
      type: "POST",
      data: {
        _token: CSRF_TOKEN,
        type: "setpeoples",
        people_id: peopleu_id,
        //role_id:role_id,
        name: name,
        lastname: lastname,
        middlename: middlename,
        email: email,
        mobile_phone: mobile_phone,
      },
      dataType: "JSON",
      success: function (data) {
        if (data.status == "success") {
          Swal.fire({
            icon: "success",
            title: "Настройки успешно обновлены!",
            heightAuto: false,
          }).then((value) => {
            $("#settings_people").modal("hide");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Произошла непредвиденная ошибка!",
            heightAuto: false,
          });
        }
      },
    });
  });

  $(document).on("click", ".settings_people", function () {
    var people_id = this.getAttribute("people_id");

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/peoplestable",
      type: "POST",
      data: {
        _token: CSRF_TOKEN,
        type: "getpeopleoneinfo",
        people_id: people_id,
      },
      dataType: "JSON",
      success: function (data) {
        document
          .getElementById("settings_people_main_save_btn")
          .setAttribute("user_id", data.id);
        document.getElementById("settings_people_secondname").value =
          data.secondname;
        document.getElementById("settings_people_firstname").value =
          data.firstname;
        document.getElementById("settings_people_middlename").value =
          data.middlename;
        document.getElementById("settings_people_email").value = data.email;
        document.getElementById("settings_people_phone").value = data.phone;
        document.getElementById("settings_people_login").value = data.login;
        document.getElementById("settings_people_password").value =
          data.password;
        //document.getElementById('settings_people_type').option = data.type;
        $("#leaveCode").val(data.type);
      },
    });
  });

  function AjaxErrorExceptionAlert(data, exception) {
    if (data.status === 0) {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + data.status,
        html: "<center>Проверьте подключение к интернету</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          data.status +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (data.status == 404) {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + data.status,
        html: "<center>Сервер недоступен</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          data.status +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (data.status == 419) {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + data.status,
        html: "<center>Неавторизованное соединение</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          data.status +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (data.status == 500) {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + data.status,
        html: "<center>Внутренняя ошибка сервера</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          data.status +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (exception === "parsererror") {
      Swal.fire({
        icon: "error",
        title: "Ошибка #" + exception,
        html: "<center>Невозможно обработать JSON ответ</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          exception +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (exception === "timeout") {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + exception,
        html: "<center>Время ожидания истекло</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          exception +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else if (exception === "abort") {
      Swal.fire({
        icon: "warning",
        title: "Ошибка #" + exception,
        html: "<center>Запрос остановлен</center>",
        footer:
          '<a id = "MailSupport" theme = "Ошибка #' +
          exception +
          '" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Неизвестная ошибка",
        html: "<center>" + data.responseText.substr(0, 50) + "</center>",
        footer:
          '<a id = "MailSupport" href = "javascript:void();">Написать в службу поддержки</a>',
        heightAuto: false,
      });
    }
  }

  $(document).on("click", ".send_loading", function () {
    Swal.fire({
      title: "Отправляем, ожидайте",
      allowOutsideClick: false,
      allowEscapeKey: false,
      heightAuto: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
  });

  $(document).on("click", ".email_preview_load", function () {
    var email_preview = document.getElementById("email_preview");
    var preview_details = this.getAttribute("preview_details");
    $.get(
      "emailtemplate",
      { type: this.getAttribute("type_email"), test: "true" },
      function (data) {
        //$('#email_preview').html(data);
        email_preview.src =
          "/alert/template/email?type=student&test=true&accessblocks=" +
          preview_details;
      }
    );
  });

  $(document).on("click", ".detail_requests4services", function () {
    // var requests4services_id = this.getAttribute('order_id');

    var requests4services_id = this.getAttribute("id");
    var view = "distance";

    sessionStorage.setItem("requests4services_id", requests4services_id);

    loaddistancepage(requests4services_id, view);

    // $('#personal_settings').show();
    // $('#settings_notices').show();
    // $('#personal_settings').click();

    switch_tabs(
      "#distance_settings",
      "#personal_settings",
      "#presonalSettings"
    );

    $("#distance_content").css("display", "none");
  });

  function loaddistancepage(requests4services_id, view) {
    console.log(
      "Requests4ServicesID: " + requests4services_id + " View: " + view
    );
    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");
    sessionStorage.setItem("alerts_r4s_id", requests4services_id);

    $.get(
      "getMainSettingsGroup",
      { id: requests4services_id, view: view, _token: CSRF_TOKEN },
      function (data) {
        $(".main_settings_group").html(data);
      }
    );
    $.get(
      "getPersons4Services",
      { id: requests4services_id, view: "p4spass", _token: CSRF_TOKEN },
      function (data) {
        $("#persons4servicespass").html(data);
      }
    );
    // $.get('getPersons4Services', {id: requests4services_id,view:'p4spass', _token: CSRF_TOKEN}, function (data) {
    //     $('#persons4servicespass').html(data);
    // });
    $.get(
      "getPersons4Services",
      { id: requests4services_id, view: view, _token: CSRF_TOKEN },
      function (data) {
        $("#persons4services").html(data);
      }
    );

    $.ajax({
      url: "/getSendDelayInfo",
      type: "POST",
      data: {
        r4s_id: requests4services_id,
        _token: CSRF_TOKEN,
      },
      dataType: "JSON",
      success: function (data) {},
    });
  }

  $(document).on("click", "#general_orders_tab", function () {
    // $('#distance_content').css('display','block');

    // $('#stats4exam').css('display','none');

    // $('#stats4exam').removeClass('active');

    switch_tabs(
      "#distance_settings",
      "#general_orders_tab",
      "#distance_content"
    );

    $("#personal_settings").addClass("hide");

    $("#settings_notices").addClass("hide");

    $("div#main-tab-content").find("div.tab-pane").hide();
  });

  $(document).on("click", "#control_main_tab", function () {
    $("div#main-tab-content").find("div.tab-pane").hide();

    switch_tabs("#control_study", "#control_main_tab", "#exampleTop");

    $("#stats_study").addClass("hide");

    $(".stats4exam_link").addClass("hide");
  });

  $(".settings_notices").bind("click", function () {
    switch_tabs("#distance_settings", "#settings_notices", "#alertsSettings");

    // $('div#main-tab-content').find('div.tab-pane').hide();
  });

  $(document).on("click", "#settings_notices", function () {
    switch_tabs("#distance_settings", "#settings_notices", "#alertsSettings");

    $("div#main-tab-content").find("div.tab-pane").hide();
  });

  function switch_tabs($ul_id, $link_active_tab_id, $active_tab_id) {
    $(".nav-item").removeClass("hide");

    $($ul_id).find(".nav-link").removeClass("active");

    $($link_active_tab_id).find("a.nav-link").addClass("active");

    $("div#main-tab-content").find("div.tab-pane").removeClass("active");

    $("div.tab-content").find($active_tab_id).addClass("active");

    $($active_tab_id).show();

    // $($active_tab_id).css('display','block');
  }

  $(document).on("click", "#statistics_cerf", function () {
    $("#services_cerf_tab").removeClass("active");

    $("#services_cerf_tab").hide();

    $("#requests_cerf_tab").removeClass("active");

    $("#requests_cerf_tab").hide();

    $("#statistics_cerf_tab").addClass("active");
  });

  $(document).on("click", "#persons_cerf", function () {
    $("#shedule_cerf_tab").removeClass("active");

    $("#shedule_cerf_tab").hide();

    $("#persons_cerf_tab").addClass("active");
  });

  $(document).on("click", "#shedule_cerf", function () {
    $("#persons_cerf_tab").removeClass("active");

    $("#persons_cerf_tab").hide();

    $("#shedule_cerf_tab").addClass("active");
  });

  $(document).on("click", "#requests_cerf", function () {
    $("#services_cerf_tab").removeClass("active");

    $("#services_cerf_tab").hide();

    $("#requests_cerf_tab").addClass("active");

    $("#statistics_cerf_tab").removeClass("active");

    $("#statistics_cerf_tab").hide();
  });

  $(document).on("click", "#services_cerf", function () {
    $("#services_cerf_tab").addClass("active");

    $("#requests_cerf_tab").removeClass("active");

    $("#requests_cerf_tab").hide();

    $("#statistics_cerf_tab").removeClass("active");

    $("#statistics_cerf_tab").hide();
  });

  $(document).on("click", "#settings_notices", function () {
    $("#Access").addClass("active");
    $("#settings_notices").show();

    $(".access-ul").find(".nav-link").removeClass("active");

    $("#access-li").find("a.nav-link").addClass("active");

    $("#PersonalShtatNotice").removeClass("#active");

    $("#PersonalShtatNotice").css("display", "none");

    $("#PersonalNotice").removeClass("active");

    $("#PersonalNotice").css("display", "none");

    $("#Access").addClass("active");

    $("#Access").css("display", "block");
  });

  $(document).on("click", "#personalShtatNotice-li", function () {
    $("#PersonalShtatNotice").addClass("#active");

    $("#PersonalShtatNotice").css("display", "block");

    $("#PersonalNotice").removeClass("active");

    $("#PersonalNotice").css("display", "none");

    $("#Access").removeClass("active");

    $("#Access").css("display", "none");
  });

  $(document).on("click", "#personalNotice-li", function () {
    $("#Access").css("display", "none");
  });

  $(document).on("click", ".hover", function () {
    var type = "info";
    if ($(this).attr("type")) {
      type = $(this).attr("type");
    }

    Swal.fire({
      type: type,
      html: $(this).attr("rel"),
      confirmButtonText: HSE_lang.confirmButtonText,
      heightAuto: false,
    });
  });

  $(document).on("click", ".table-secondary", function () {
    Swal.fire({
      icon: "warning",
      title: "Внимание!",
      html: "<center>Оплатите заявку для настройки услуги!</center>",
      heightAuto: false,
    });

    // ModalAlert('Внимание', 'Оплатите заявку для настройки услуги!','warning');
  });

  $(document).on("click", "#disabled-tests", function () {
    Swal.fire({
      type: "success",
      html: $(this).attr("rel"),
      confirmButtonText: HSE_lang.confirmButtonText,
      heightAuto: false,
    });
  });

  $(document).on("click", "#MailSupport", function () {
    console.log($(this).attr("theme"));
    if ($(this).attr("theme") === undefined) {
      $("#support_mail_head").val(
        $("#support_mail_head").attr("default-value")
      );
    } else {
      $("#support_mail_head").val($(this).attr("theme"));
    }
    $("#modalmail_alert").hide();
    $("#support_mail_text").val("");
    ModalMail();
  });

  $(document).on("click", "#mail-support", function () {
    var topic = document.getElementById("support_mail_head").value;
    var message = document.getElementById("support_mail_text").value;
    if (
      message != "" &&
      message != null &&
      message != undefined &&
      topic != "" &&
      topic != null &&
      topic != undefined
    ) {
      $.ajax({
        url: "/alert/service/support",
        type: "POST",
        data: {
          topic: document.getElementById("support_mail_head").value,
          message: document.getElementById("support_mail_text").value,
          _token: $('meta[name="csrf-token"]').attr("content"),
        },
        dataType: "JSON",
        success: function (data) {
          $("#ModalMail").modal("hide");
          Swal.fire({
            icon: data.status,
            title: data.message,
            heightAuto: false,
          });
        },
      });
    } else {
      document
        .getElementById("modalmail_alert")
        .setAttribute("class", "alert alert-danger alert-dismissible");
      $("#modalmail_alert_text").html("Заполните все поля!");
      $("#modalmail_alert").show();
    }
  });

  //Отправка письма эксперту
  $(document).on('click', '#ExpertMessage', function () {
    console.log('приффки');
    console.log($(this).attr('theme'));

    if ($(this).attr('theme') === undefined) {
      $('#expert_mail_head').val($('#expert_mail_head').attr('default-value'));
    } else {
      $('#expert_mail_head').val($(this).attr('theme'));
    }

    $('#expert_modalmail_alert').hide();
    $('#expert_mail_text').val('');
    ModalMailExpert();
  });
  $(document).on('click', '#expert_mail-support', function () {
    var topic = document.getElementById('expert_mail_head').value;
    var message = document.getElementById('expert_mail_text').value;
    var email = document.getElementById('email4feedback').value;

    if (message != '' && message != null && message != undefined && topic != '' && topic != null && topic != undefined && email != '' && email != null && email != undefined) {
      $.ajax({
        url: '/alert/service/expert_message',
        type: 'POST',
        data: {
          topic: document.getElementById('expert_mail_head').value,
          message: document.getElementById('expert_mail_text').value,
          email: document.getElementById('email4feedback').value,
          topic_id: document.getElementById('topic_id').value,
          user_id: document.getElementById('user_id').value,
          full_url: document.getElementById('full_url').value,
          theme_id: document.getElementById('theme_id').value,
          _token: $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'JSON',
        success: function success(data) {
          $('#ModalMailExpert').modal('hide');
          swal.fire({
            type: data.status,
            title: data.message,
            heightAuto: false
          });
        }
      });
    } else {
      document.getElementById('expert_modalmail_alert').setAttribute('class', 'alert alert-danger alert-dismissible');
      $('#expert_modalmail_alert_text').html('Заполните все поля!');
      $('#expert_modalmail_alert').show();
    }
  });

  // Запрет закрытия сообщения при нажатии на элемент закрытия
  $("#modalmail_alert").on("click", ".close", function (e) {
    e.stopPropagation(); // Предотвращает всплытие события и закрытие сообщения
  });

  $("#work_orders").bind("click", function () {
    $(".nav-item").removeClass("hide");
  });

  $("#price_btn").bind("click", function () {
    $(".nav-item").removeClass("hide_price");
  });

  //Переделать в функцию начало
  $("#students4requests").bind("click", function () {
    $("#requests").find(".nav-item").removeClass("hide_students");

    $("#requests").find(".nav-link").removeClass("active");

    $("#service4requests").addClass("active");

    $("#exampleTopComponents").hide();

    $("#Students4Requests").show();
  });

  $("#general_orders_tab").bind("click", function () {
    $(".more_orders").addClass("hide");

    $(".students").addClass("hide_students");
  });

  //Переделать в функцию конец
  $("#add_task").bind("click", function () {
    var text_task = document.getElementById("text_task").value;

    var appendString = "";

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "todo",
      type: "POST",
      data: { _token: CSRF_TOKEN, title: text_task },
      dataType: "JSON",
      success: function (data) {
        appendString +=
          "<div class='checkbox-custom checkbox-primary mb-15'><input type='checkbox' name='checkbox'><label id=" +
          data.id +
          " class='tasks-title-label edit_task'>" +
          text_task +
          "</label>\
                <button id=" +
          data.id +
          " type='button' class='btn btn-pure btn-default icon md-delete p-0 btn-trash'></button></div>";

        $("#tasks_list").append(appendString);
      },
    });
  });

  $("#add_sub").bind("click", function () {
    var text_sub = document.getElementById("text_sub").value;

    var appendString = "";

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "sub",
      type: "POST",
      data: { _token: CSRF_TOKEN, name: text_sub },
      dataType: "JSON",
      success: function (data) {
        appendString +=
          "<div class='checkbox-custom checkbox-primary mb-15'><input type='checkbox' name='checkbox'><label id=" +
          data.id +
          " class='tasks-title-label edit_task'>" +
          text_sub +
          "</label>\
                <button id=" +
          data.id +
          " type='button' class='btn btn-pure btn-default icon md-delete p-0 btn-trash'></button></div>";

        $("#subdomains_list").append(appendString);
      },
    });
  });

  $("#addSotrRequests").bind("click", function () {
    var lastname = document.getElementById("lastname").value;
    var firstname = document.getElementById("firstname").value;
    var middlename = document.getElementById("middlename").value;
    var position = document.getElementById("position").value;
    var birth_date = document.getElementById("birth_date").value;
    var phone_number = document.getElementById("phone_number").value;
    var email = document.getElementById("email").value;

    var appendString = "";

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "user",
      type: "POST",
      data: {
        _token: CSRF_TOKEN,
        lastname: lastname,
        firstname: firstname,
        middlename: middlename,
        position: position,
        birth_date: birth_date,
        phone_number: phone_number,
        email: email,
      },
      dataType: "JSON",
      success: function (data) {
        alert(data);
      },
    });
  });

  $(".tr_request").bind("click", function () {
    var trId = $(this).attr("id");

    $(".table").find(".table-select").removeClass("table-select");

    $("#" + trId).toggleClass("table-select");

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    var appendString = "";

    $.ajax({
      url: "/getUsersForRequests",
      type: "GET",
      data: { _token: CSRF_TOKEN, message: trId },
      dataType: "JSON",
      success: function (data) {
        $("#sms_result").html(data.html);
      },
    });

    //  $.ajax({

    //   url: '/getResultTable',
    //   type: 'GET',
    //   data: {_token: CSRF_TOKEN, message:trId},
    //   dataType: 'JSON',
    //   success: function (data) {

    //     alert(data);

    //   }

    // });
  });

  // $('#ru').bind('click', function () {
  //     sessionStorage.setItem('site_lang', 'ru');
  //     localStorage.setItem('bangie_lang', 'ru');
  //     localStorage.setItem('bangie_lang_check', '0');
  // });

  // $('#en').bind('click', function () {
  //     sessionStorage.setItem('site_lang', 'en');
  //     localStorage.setItem('bangie_lang', 'en');
  //     localStorage.setItem('bangie_lang_check', '0');
  // });
  // if (window.location.pathname == '/login') {
  //     localStorage.setItem('bangie_lang_check', '0');
  // }
  // if ((localStorage.getItem('bangie_lang_check') != '1' || localStorage.getItem('bangie_lang') != sessionStorage.getItem('site_lang')) && window.location.pathname != '/login') {
  //     localStorage.setItem('bangie_lang_check_login', '0');
  //     sessionStorage.setItem('site_lang', localStorage.getItem('bangie_lang'));
  //     localStorage.setItem('bangie_lang_check', '1');
  //     var CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
  //     $.ajax({
  //         url: '/setlang',
  //         type: 'GET',
  //         data: {_token: CSRF_TOKEN, language: localStorage.getItem('bangie_lang')},
  //         dataType: 'JSON',
  //         success: function (data) {
  //             //alert(data.language + data.status + data.session + data.locale + data.config);
  //             //location.reload();
  //             window.location.href = "/home";
  //         }
  //     });
  // }

  $(".table-result").bind("click", function () {
    var tableId = $(this).attr("id");
    var result_id = $(this).attr("href");
    $(".table").find(".table-select").removeClass("table-select");

    $("#" + tableId).toggleClass("table-select");

    $("#last_exam").attr("href", "results/" + result_id);

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    $.ajax({
      url: "/getResultTable",
      type: "GET",
      data: { _token: CSRF_TOKEN, message: tableId },
      dataType: "JSON",
      success: function (data) {
        $(".result-body").html(data.html);
      },
    });
  });

  $(".page-sidebar").on("click", "li > a", function (e) {
    if (
      $("body").hasClass("page-sidebar-closed") &&
      $(this).parent("li").parent(".page-sidebar-menu").size() === 1
    ) {
      return;
    }

    var hasSubMenu = $(this).next().hasClass("sub-menu");

    if ($(this).next().hasClass("sub-menu always-open")) {
      return;
    }

    var parent = $(this).closest();
    var the = $(this);
    var menu = $(".page-sidebar-menu");
    var sub = $(this).next();

    var autoScroll = menu.data("auto-scroll");
    var slideSpeed = parseInt(menu.data("slide-speed"));
    var keepExpand = menu.data("keep-expanded");

    if (keepExpand !== true) {
      parent
        .children("li.open")
        .children("a")
        .children(".arrow")
        .removeClass("open");
      parent
        .children("li.open")
        .children(".sub-menu:not(.always-open)")
        .slideUp(slideSpeed);
      parent.children("li.open").removeClass("open");
    }

    var slideOffeset = -200;

    if (sub.is(":visible")) {
      $(".arrow", $(this)).removeClass("open");
      $(this).parent().removeClass("open");
      sub.slideUp(slideSpeed, function () {
        if (
          autoScroll === true &&
          $("body").hasClass("page-sidebar-closed") === false
        ) {
          if ($("body").hasClass("page-sidebar-fixed")) {
            menu.slimScroll({
              scrollTo: the.position().top,
            });
          }
        }
      });
    } else if (hasSubMenu) {
      $(".arrow", $(this)).addClass("open");
      $(this).parent().addClass("open");
      sub.slideDown(slideSpeed, function () {
        if (
          autoScroll === true &&
          $("body").hasClass("page-sidebar-closed") === false
        ) {
          if ($("body").hasClass("page-sidebar-fixed")) {
            menu.slimScroll({
              scrollTo: the.position().top,
            });
          }
        }
      });
    }
    if (hasSubMenu == true || $(this).attr("href") == "#") {
      e.preventDefault();
    }
  });
});

$(document).on("click", ".delete_task", function () {
  $(this).task_delete();
});

$(document).on("click", ".edit_task", function () {
  $(this).task_editor();
});

(function ($) {
  $.fn.task_editor = function () {
    alertify.defaults = {
      // dialogs defaults
      autoReset: true,
      basic: false,
      closable: true,
      closableByDimmer: true,
      frameless: false,
      maintainFocus: true, // <== global default not per instance, applies to all dialogs
      maximizable: true,
      modal: true,
      movable: true,
      moveBounded: false,
      overflow: true,
      padding: true,
      pinnable: true,
      pinned: true,
      preventBodyShift: false, // <== global default not per instance, applies to all dialogs
      resizable: true,
      startMaximized: false,
      transition: "pulse",

      // notifier defaults
      notifier: {
        // auto-dismiss wait time (in seconds)
        delay: 5,
        // default position
        position: "bottom-right",
        // adds a close button to notifier messages
        closeButton: false,
      },

      // language resources
      glossary: {
        // dialogs default title
        title: "",
        // ok button text
        ok: "Сохранить",
        // cancel button text
        cancel: "Отмена",
      },

      // theme settings
      theme: {
        // class name attached to prompt dialog input textbox.
        input: "form-control",
        // class name attached to ok button
        ok: "ok btn btn-primary",
        // class name attached to cancel button
        cancel: "cancel btn btn-default",
      },
    };

    var task_text = $(this).text();
    var task_id = $(this).attr("id");
    var compleated = $("#" + task_id + ".task-check").prop("checked");
    var myurl = "todo/" + task_id;

    if (compleated == true) {
      compleated = 1;
    } else {
      compleated = 0;
    }

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    alertify.prompt(
      "",
      task_text,
      function (evt, value) {
        $.ajax({
          url: myurl,
          type: "PUT",
          data: { _token: CSRF_TOKEN, title: value, compleated: compleated },
          dataType: "JSON",
          success: function (data) {
            $("#" + task_id + ".tasks-title-label").html(value);
          },
        });

        alertify.success("Обновлена задача: " + value);
        // $('#'+task_id).html(value);
      },
      function () {
        alertify.error(":(");
      }
    );
  };
})(jQuery);

(function ($) {
  $.fn.task_delete = function () {
    alertify.defaults = {
      // dialogs defaults
      autoReset: true,
      basic: false,
      closable: true,
      closableByDimmer: true,
      frameless: false,
      maintainFocus: true, // <== global default not per instance, applies to all dialogs
      maximizable: true,
      modal: true,
      movable: true,
      moveBounded: false,
      overflow: true,
      padding: true,
      pinnable: true,
      pinned: true,
      preventBodyShift: false, // <== global default not per instance, applies to all dialogs
      resizable: true,
      startMaximized: false,
      transition: "pulse",

      // notifier defaults
      notifier: {
        // auto-dismiss wait time (in seconds)
        delay: 5,
        // default position
        position: "bottom-right",
        // adds a close button to notifier messages
        closeButton: false,
      },

      // language resources
      glossary: {
        // dialogs default title
        title: "",
        // ok button text
        ok: "Удалить",
        // cancel button text
        cancel: "Отмена",
      },

      // theme settings
      theme: {
        // class name attached to prompt dialog input textbox.
        input: "form-control",
        // class name attached to ok button
        ok: "ok btn btn-danger",
        // class name attached to cancel button
        cancel: "cancel btn btn-default",
      },
    };

    var task_id = $(this).attr("id");
    var myurl = "todo/" + task_id;

    var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

    alertify.confirm(
      "Удалить задачу?",
      function () {
        alertify.success("Задача удалена");

        $.ajax({
          url: myurl,
          type: "DELETE",
          data: { _method: "delete", _token: CSRF_TOKEN },
          success: function (data) {
            $("div#" + task_id).remove();
          },
        });
      },
      function () {
        alertify.error(":(");
      }
    );
  };
})(jQuery);

$(document).on("click", ".task-check", function () {
  var compleated = $(this).prop("checked");
  var task_id = $(this).attr("id");
  var myurl = "todo/" + task_id;

  if (compleated == true) {
    compleated = 1;
  } else {
    compleated = 0;
  }

  var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

  $.ajax({
    url: myurl,
    type: "PUT",
    data: { _token: CSRF_TOKEN, compleated: compleated },
    dataType: "JSON",
    success: function (data) {},
  });
});

$(document).on("click", ".like-comment", function () {
  var type = $(".class").attr("rel");
  var entity_id = $(this).attr("rel");
  var entity_type = $(".class").attr("rel");

  var task_id = $(this).attr("id");
  var myurl = "todo/" + task_id;

  if (compleated == true) {
    compleated = 1;
  } else {
    compleated = 0;
  }

  var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

  $.get(
    "/like/up",
    { type: type, entity_id: entity_id, entity_type: entity_type },
    function (data) {
      $("#like").value(data.like);
    }
  );
});

$(document).on("click", ".task-check", function () {
  var compleated = $(this).prop("checked");
  var task_id = $(this).attr("id");
  var myurl = "todo/" + task_id;

  if (compleated == true) {
    compleated = 1;
  } else {
    compleated = 0;
  }

  var CSRF_TOKEN = $('meta[name="csrf-token"]').attr("content");

  $.ajax({
    url: myurl,
    type: "PUT",
    data: { _token: CSRF_TOKEN, compleated: compleated },
    dataType: "JSON",
    success: function (data) {},
  });
});

$("#username").ready(function () {
  if (document.getElementById("username") !== null) {
    if (document.getElementById("username").value === "")
      $("#username").addClass("empty");
    if (document.getElementById("username").value !== "")
      $("#username").removeClass("empty");
  }
});

$("#lastname").ready(function () {
  if (document.getElementById("lastname") !== null) {
    if (document.getElementById("lastname").value === "")
      $("#lastname").addClass("empty");
    if (document.getElementById("lastname").value !== "")
      $("#lastname").removeClass("empty");
  }
});
$("#password_recovery_username").ready(function () {
  if (document.getElementById("password_recovery_username") !== null) {
    if (document.getElementById("password_recovery_username").value === "")
      $("#password_recovery_username").addClass("empty");
    if (document.getElementById("password_recovery_username").value !== "")
      $("#password_recovery_username").removeClass("empty");
  }
});

$(document).on("focus", ".register-form-field", function () {
  $(this).removeClass("empty");
});

$(document).on("blur", ".register-form-field", function () {
  if ($(this)[0].value == "") {
    $(this).addClass("empty");
  } else {
    $(this).removeClass("empty");
  }
});

jQuery(function ($) {
  $(document).mouseup(function (e) {
    var div = $("#password");

    if (!div.is(e.target)) {
      if (document.getElementById("password") !== null) {
        if (document.getElementById("password").value != null) {
          if (document.getElementById("password").value !== "") {
            $("#password").removeClass("empty");
          } else {
            $("#password").addClass("empty");
          }
        }
      }
    }
  });
});

$(document).on("keypress", function (e) {
  if (e.which == 9) {
    alert("You pressed enter!");
  }
});

$("#username").focusout(function () {
  if (document.getElementById("username") !== null) {
    if (document.getElementById("username").value != null) {
      if (document.getElementById("username").value !== "") {
        $("#username").removeClass("empty");
      } else {
        $("#username").addClass("empty");
      }
    }
  }
});

$("#password").focusout(function () {
  if (document.getElementById("password") !== null) {
    if (document.getElementById("password").value != null) {
      if (document.getElementById("password").value !== "") {
        $("#password").removeClass("empty");
      } else {
        $("#password").addClass("empty");
      }
    }
  }
});

jQuery(function ($) {
  $(document).mouseup(function (e) {
    var div = $("#username");
    if (!div.is(e.target)) {
      if (document.getElementById("username") !== null) {
        if (document.getElementById("username").value != null) {
          if (document.getElementById("username").value !== "") {
            $("#username").removeClass("empty");
          } else {
            $("#username").addClass("empty");
          }
        }
      }
    }
  });
});

$(document).on("click", ".profile_save_password", function () {
  var old_password = document.getElementById("profile_old_password").value;
  var new_password = document.getElementById("profile_new_password").value;
  var new_repeat_password = document.getElementById(
    "profile_new_repeat_password"
  ).value;
  if (new_password != "" && new_repeat_password != "" && old_password != "") {
    if (new_password == new_repeat_password) {
      $.post(
        "/profileedit",
        {
          action: "updatepassword",
          _token: $('meta[name="csrf-token"]').attr("content"),
          old_password: old_password,
          new_password: new_repeat_password,
        },
        function (data) {
          if (data.status == "success") {
            Swal.fire({
              type: "success",
              title: "Пароль успешно изменен!",
              heightAuto: false,
            });
          } else {
            Swal.fire({
              type: "warning",
              title: "Старый пароль не совпадает!",
              heightAuto: false,
            });
          }
        }
      );
    } else {
      Swal.fire({
        type: "warning",
        title: "Новые пароли не совпадают!",
        heightAuto: false,
      });
    }
  } else {
    Swal.fire({
      type: "warning",
      title: "Поля не могут быть пустыми!",
      heightAuto: false,
    });
  }
});

function ModalAlert(title, text, type) {
  //primary,success,danger,warning,info
  document.getElementById("modal_alert_title").innerHTML = title;
  document.getElementById("modal_alert_text").innerHTML = text;
  document
    .getElementById("ModalAlert")
    .setAttribute("class", "modal fade modal-" + type);
  $("#ModalAlert").modal("show");
}

function ModalMail(type = "warning") {
  //primary,success,danger,warning,info
  document
    .getElementById("ModalMail")
    .setAttribute("class", "modal fade modal-warning");
  $("#ModalMail").modal("show");
}

function ModalMailExpert() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'warning';

  document.getElementById('ModalMailExpert').setAttribute('class', 'modal fade modal-warning');
  $('#ModalMailExpert').modal('show');
}

//Export Excel

$(document).on("click", ".download_all_orders", function () {
  var headings = [];
  var id = -1;

  var cbx = document.getElementById("headings1").getElementsByTagName("input");

  for (var i = 0; i < cbx.length; i++) {
    if (cbx[i].type == "checkbox" && cbx[i].checked) {
      if (cbx[i].value != "undefined") headings.push(cbx[i].value);
    }
  }

  headings = JSON.stringify(headings);

  window.location = "/download_orders?id=" + id + "&headings=" + headings;
});

$(document).on("click", ".excel", function () {
  var id = $(this).attr("id");

  var chosenOrder = document.getElementById(id + "-string");

  var modalTable = document.getElementById("modal_string");

  modalTable.innerHTML = chosenOrder.innerHTML;

  $(".download_order").attr("id", id);
});

$(document).on("click", ".download_order", function () {
  var id = $(this).attr("id");

  var headings = [];

  var cbx = document.getElementById("headings2").getElementsByTagName("input");

  for (var i = 0; i < cbx.length; i++) {
    if (cbx[i].type == "checkbox" && cbx[i].checked) {
      if (cbx[i].value != "undefined") headings.push(cbx[i].value);
    }
  }

  headings = JSON.stringify(headings);

  window.location =
    "/download_orders?id=" + $(this).attr("id") + "&headings=" + headings;
});

function send_reset_password_mail(user_id) {
  $.ajax({
    url: "/password_reset_send",
    type: "POST",
    data: {
      _token: $('meta[name="csrf-token"]').attr("content"),
      user_id: user_id,
    },
    success: function (data) {
      Swal.fire({
        icon: data.status,
        title: data.message,
        heightAuto: false,
      });
    },
  });
}

$(document).on("click", ".password_recovery", function () {
  let form = document.getElementById("password_recovery_form");
  $.ajax({
    url: window.location.pathname,
    type: "POST",
    data: new FormData(form),
    processData: false,
    contentType: false,
    success: function (data) {
      console.log(data);
      if (data.status === "success") {
        Swal.fire({
          title: "Это вы?<br>",
          text: "Имя пользователя: " + data.username,
          heightAuto: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText:
            '<span id="yes-reset-pswd">Да, это мой аккаунт</span>',
          cancelButtonText: "Нет",
        }).then((result) => {
          if (result.value) {
            send_reset_password_mail(data.user_id);
          }
        });
      }

      if (data.status === "error") {
        Swal.fire({
          icon: "error",
          title: data.message,
          heightAuto: false,
        });
      }
    },
  });
});

$(document).ready(function () {
  if (!ExURL.login() && !ExURL.isKnpSnappyFileForQReports()) {
    if (sessionStorage.getItem("greeting") == null) {
      $.get('/greeting', function (data) {
        if (data.show == 'true') {
          let swalWithBootstrapButtons = Swal.mixin();

          swalWithBootstrapButtons.fire({
            type: 'success',
            html: data.text,
            heightAuto: false,
            confirmButtonText: "Да",
            cancelButtonText: "Нет, оставить текущий",
            showCancelButton: true
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.close();
            } else {
              window.location.href = '/profile';
            }
          });
        }
        sessionStorage.setItem("greeting", 'false');
      });
    }
  }
});

$(".login_clear_session").ready(function () {
  if (window.location.pathname == "/login") {
    sessionStorage.clear("greeting");
  }
});

function langGet(phrase) {
  fetch("/getLanguage/" + phrase).then(function (response) {
    return response.text;
  });
}

$(document).click(function (e) {
  let drop_menu = $(".dropdown-menu-left");
  if (!$(drop_menu).is(e.target)) {
    $(drop_menu).dropdown("hide");
  }
});

$("#calendarOpen").click(function () {
  $.ajax({
    url: "/calendar2/{act?}",
    type: "GET",

    success: function (res) {
      $("#toggleCalendar").find(".dropdown-menu").html(res);

      $("#calendarOpen").unbind();
    },
  });
});
